//hooks
import { useState, useEffect } from 'react';
import { useApi } from '../../hooks/useApi';

//mui
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

//mui icon
import ReplayIcon from '@mui/icons-material/Replay';

//mui date piker
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

//tranlsaie
import { useTranslation } from "react-i18next";

//moment
import moment from 'moment';

//type
import { carType } from '../../api/Cars/type/CarsType';

//api
import { GetAvailableCarsApi } from '../../api/Cars/GetAvailableCarsApi';
import { GetCategoryListApi } from '../../api/category/GetCategoryListApi';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface AvailableCarsFilterProps {
  setAvailableCarsData: (availableCarsData: carType[]) =>void
  page: number,
  setPage: (page: number) =>void
  setInitialLoading: (open: boolean) =>void,
}

const names = ["petrol", "diesel", "electric", "hybrid"];

const AvailableCarsFilter = ({setAvailableCarsData, page, setPage, setInitialLoading}:AvailableCarsFilterProps) => {
  const { t } = useTranslation();
  const {
    loading: availableCarLoading,
    error: availableCarError,
    HandlerApi: getAvailableCars
  } = useApi(GetAvailableCarsApi, "GET");
  const {
      loading: categoryLoading,
      error: categoryError,
      HandlerApi: getCategory
  } = useApi(GetCategoryListApi, "GET")
  const [filtersData, setFiltersData] = useState({
      start_date: null,
      end_date: null,
      fuel_type: "",
      category_id: "",
      seating_capacity: 0,
      is_daily: 0,
      daily_price: 0,
      is_weekly: 0,
      weekly_price: 0,
      is_monthly: 0,
      monthly_price: 0,
      per_page: '8',
      page: page,
  });
  let [categoryList, setcategoryList] = useState<any[]>([]);
  
  const isFilterEmpty =
  filtersData.start_date === null &&
  filtersData.end_date === null &&
  filtersData.fuel_type === "" &&
  filtersData.category_id === "" &&
  filtersData.seating_capacity === 0 &&
  filtersData.is_daily === 0 &&
  filtersData.daily_price === 0 &&
  filtersData.is_weekly === 0 &&
  filtersData.weekly_price === 0 &&
  filtersData.is_monthly === 0 &&
  filtersData.monthly_price === 0;

  useEffect(() => {
      const fetchData = () => {
          getCategory().then((res) => {
              setcategoryList(res.data);
          })
          .catch(() => {});
      }
      fetchData();
  },[])

  const handleChange = (field: string, value: any) => {
    if(field === "is_daily" ) {
      setFiltersData(prev => ({ ...prev, [field]: value === true ? 1 : 0 }));
      if(value === false) {
        setFiltersData(prev => ({ ...prev, [`daily_price`]: 0 }));
      }
    }
    else if(field === "is_weekly") {
      setFiltersData(prev => ({ ...prev, [field]: value === true ? 1 : 0 }));
      if(value === false) {
        setFiltersData(prev => ({ ...prev, [`weekly_price`]: 0 }));
      }
    }
    else if(field === "is_monthly") {
      setFiltersData(prev => ({ ...prev, [field]: value === true ? 1 : 0 }));
      if(value === false) {
        setFiltersData(prev => ({ ...prev, [`monthly_price`]: 0 }));
      }
    }
    else {
      setFiltersData(prev => ({ ...prev, [field]: value }));
    }
  };

  const handleSubmitFilter = async () => {
    const params: any = {};
    Object.entries(filtersData).forEach(([key, value]) => {
      if (value !== null && value !== "" && value !== 0) {
        params[key] = value;
      }
    });
    setInitialLoading(true);
    setPage(1)
    const resultBestCars = await getAvailableCars(params);
    setAvailableCarsData(resultBestCars.data.data);
    setInitialLoading(false);
    // setFiltersData({
    //   start_date: null,
    //   end_date: null,
    //   fuel_type: "",
    //   seating_capacity: 0,
    //   is_daily: 0,
    //   daily_price: 0,
    //   is_weekly: 0,
    //   weekly_price: 0,
    //   is_monthly: 0,
    //   monthly_price: 0,
    //   per_page: '6',
    //   page: page,
    // });
  };
  const handleDeleteFilter = async ()=> {
    setFiltersData({
      start_date: null,
      end_date: null,
      fuel_type: "",
      category_id: "",
      seating_capacity: 0,
      is_daily: 0,
      daily_price: 0,
      is_weekly: 0,
      weekly_price: 0,
      is_monthly: 0,
      monthly_price: 0,
      per_page: '6',
      page: page,
    });
      setInitialLoading(true);
      const resultBestCars = await getAvailableCars({page: page, per_page: '8'});
      setAvailableCarsData(resultBestCars.data.data);
      setInitialLoading(false);
      setPage(1)
  }

  return (
    <div>
      <div>
        <div className="p-[14px]">
          <p >{t("filter_by_date")}</p>
        </div>
        <div className='flex flex-col gap-2 p-[10px]'>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
              label={t("start_date")}
              format="YYYY-MM-DD HH:mm:ss"
              closeOnSelect={false}
              value={filtersData.start_date ? moment(filtersData.start_date, "YYYY-MM-DD HH:mm:ss") : null}
              onChange={(newValue) =>
                handleChange('start_date', newValue ? newValue.format("YYYY-MM-DD HH:mm:ss") : null)
              }
              minDate={moment()}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePicker
              label={t("end_date")}
              format="YYYY-MM-DD HH:mm:ss"
              closeOnSelect={false}
              value={filtersData.end_date ? moment(filtersData.end_date, "YYYY-MM-DD HH:mm:ss") : null}
              onChange={(newValue) =>
                handleChange('end_date', newValue ? newValue.format("YYYY-MM-DD HH:mm:ss") : null)
              }
              minDate={moment()}
            />
          </LocalizationProvider>
        </div>
      </div>
      
      <Divider className='!mt-3'/>

      <div>
        <div className="p-[14px]">
          <p >{t("engine_type")}</p>
        </div>
        <div className='flex flex-col gap-2 p-[10px]'>
          <FormControl>
            <InputLabel id="fuel-type-label">{t("engine_type")}</InputLabel>
            <Select
              value={filtersData.fuel_type}
              onChange={(e) => handleChange('fuel_type', e.target.value)}
              input={<OutlinedInput label={t("engine_type")} />}
              MenuProps={MenuProps}
            >
              {names.map((name) => (
                <MenuItem key={name} value={name}>{t(name)}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <Divider className='!mt-3'/>

      <div>
        <div className="p-[14px]">
          <p >{t("category_type")}</p>
        </div>
        <div className='flex flex-col gap-2 p-[10px]'>
          <FormControl>
            <InputLabel id="fuel-type-label">{t("category_type")}</InputLabel>
            <Select
            value={filtersData.category_id}
            onChange={(e) => handleChange('category_id', e.target.value)}
            input={<OutlinedInput label={t("category_type")} />}
            MenuProps={MenuProps}
            >
            {
                categoryLoading
                ?
                    <div className="flex justify-center items-center gap-2">
                        <CircularProgress size={18} />
                    </div>
                :
                categoryError
                    ?
                        <div className=" cursor-pointer flex justify-center mt-4">
                            <ReplayIcon onClick={()=>{getCategory()}} className='!text-[25px]'/>
                        </div>
                    :
                        categoryList.map((item: any) => (
                            <MenuItem key={item.id} value={item.id}>
                            {item.name}
                            </MenuItem>
                        ))}
            </Select>
          </FormControl>
        </div>
      </div>

      <Divider className='!mt-3'/>

      <div>
        <div className="p-[14px]">
          <p >{t("passengers")}</p>
        </div>
        <div className='flex flex-col gap-2 p-[10px]'>
          <TextField
            label={t("seating_capacity")}
            variant="outlined"
            type='number'
            value={filtersData.seating_capacity}
            onChange={(e) => handleChange('seating_capacity', Number(e.target.value))}
          />
        </div>
      </div>

      <Divider className='!mt-3'/>

      <div>
        <div className="p-[14px]">
          <p>{t("price_and_options")}</p>
        </div>
        <div className='p-[10px]'>
          <div className='flex flex-wrap gap-2'>
            <FormControlLabel control={<Checkbox checked={filtersData.is_daily === 1 ? true : false} onChange={(e) => handleChange('is_daily', e.target.checked)} />} label={t("is_daily")} />
            {filtersData.is_daily === 1 && (
              <TextField className='w-full mb-2' label={t("daily_price")} variant="outlined" type='number' value={filtersData.daily_price} onChange={(e) => handleChange('daily_price', Number(e.target.value))}/>
            )}
          </div>
          <div className='flex flex-wrap gap-2'>
            <FormControlLabel control={<Checkbox checked={filtersData.is_weekly === 1 ? true : false} onChange={(e) => handleChange('is_weekly', e.target.checked)} />} label={t("is_weekly")} />
            {filtersData.is_weekly === 1 && (
            <TextField className='w-full mb-2' label={t("weekly_price")} variant="outlined" type='number' value={filtersData.weekly_price} onChange={(e) => handleChange('weekly_price', Number(e.target.value))}/>
            )}
          </div>

          <div className='flex flex-col gap-2'>
            <FormControlLabel control={<Checkbox checked={filtersData.is_monthly === 1 ? true : false} onChange={(e) => handleChange('is_monthly', e.target.checked)} />} label={t("is_monthly")} />
            {filtersData.is_monthly === 1 && (
            <TextField className='w-full mb-2' label={t("monthly_price")} variant="outlined" type='number' value={filtersData.monthly_price} onChange={(e) => handleChange('monthly_price', Number(e.target.value))}/>
            )}
          </div>
        </div>
      </div>
      <Box sx={{display: "flex", flexDirection:{md:"row", xs:"column"}, gap: "5px", padding: "10px"}}>
        <Button onClick={handleSubmitFilter} 
        className={`!w-full !bg-customerColor ${isFilterEmpty ? "!opacity-50 !cursor-default" : ""} !text-white`}
        disabled={isFilterEmpty}
        >
          {availableCarLoading
          ? <CircularProgress size={32}/>
          : t("confirm_filters")

          }
        </Button>
        <Button onClick={handleDeleteFilter} className={`${isFilterEmpty ? "!opacity-50 !cursor-default" : ""} !w-full !bg-red-600 !text-white`}>{t("delete_filters")}</Button>
      </Box>
    </div>
  )
}

export default AvailableCarsFilter